import React, { Component, Fragment } from 'react';
import PropTypes from "prop-types";
import Header from "./Header";
import Footer from './Footer';

class Main extends Component {

    render() {
        const { children, className } = this.props;
        return (
            <Fragment>
                <Header />
                <main className={`all-content ${className && className}`}>
                    {children}
                </main>
                <Footer />
            </Fragment>
        );
    }
}

Main.propTypes = {
    children: PropTypes.node,
};

export default Main;
